import { Component, OnInit } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-footer-mobile-nav',
  templateUrl: './footer-mobile-nav.component.html',
  styleUrls: ['./footer-mobile-nav.component.css']
})
export class FooterMobileNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
